import './TicketShowLogisticPackageCard.scss';

import { ExportOutlined } from '@ant-design/icons';
import { Button, Card, Divider, Flex } from 'antd';
import { useTranslation } from 'react-i18next';

import LinkTextField from '@/components/general/LinkTextField';
import PackageStateTag from '@/components/logistic/PackageStateTag';
import { COMPANY_URLS } from '@/constants/urls';
import { usePermissionContext } from '@/contexts/PermissionContext';
import { Package } from '@/model/Logistic/Package';
import { RESOURCES } from '@/Resources';

interface TicketShowLogisticPackageCardProps {
  record: Package;
  type: 'shipment' | 'reception';
}

const TicketShowLogisticPackageCard = (props: TicketShowLogisticPackageCardProps) => {
  const { t } = useTranslation();
  const { hasPermission } = usePermissionContext();
  const { record, type } = props;

  return (
    <Card className="TicketShowLogisticPackageCard" title={null}>
      <div className="TicketShowLogisticPackageCardContent">
        <div className="TicketShowLogisticPackageCardData">
          {hasPermission(
            'show',
            type == 'shipment' ? RESOURCES.SHIPMENTS : RESOURCES.RECEPTIONS,
          ) ? (
            <LinkTextField
              label={`${record.id}`}
              to={`/${type == 'shipment' ? RESOURCES.SHIPMENTS : RESOURCES.RECEPTIONS}/show/${record.id}`}
              local
              withoutColor
            />
          ) : (
            record.id
          )}
          <Divider type="vertical" />
          <Flex gap={4} wrap>
            {type == 'shipment' ? <b>{t('Destino')}: </b> : <b>{t('Origen')}: </b>}
            <LinkTextField
              label={record.company?.full_name ?? '-'}
              to={`${COMPANY_URLS.ADMIN_EMPRESA}/${record.company?.id}`}
              admin
            />
          </Flex>
        </div>
        <Flex gap={4} align="center">
          {record.status != undefined ? <PackageStateTag packageStatus={record.status} /> : null}

          {hasPermission(
            'show',
            type == 'shipment' ? RESOURCES.SHIPMENTS : RESOURCES.RECEPTIONS,
          ) && (
            <Button
              size="small"
              icon={<ExportOutlined />}
              onClick={() => window.open(`/v2/${type}s/show/${record.id}`)}
            />
          )}
        </Flex>
      </div>
    </Card>
  );
};

export default TicketShowLogisticPackageCard;
